import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Extracts a human-readable error message from an API error response.
 * Handles Pydantic validation errors (array of objects with type, loc, msg, input).
 * @param {Error} error - The error object from axios catch block
 * @param {string} defaultMessage - Default message if no detail found
 * @returns {string} - The error message to display
 */
export function getErrorMessage(error, defaultMessage = "Une erreur est survenue") {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return error?.message || defaultMessage;
  }
  
  if (typeof detail === 'string') {
    return detail;
  }
  
  if (Array.isArray(detail)) {
    // Pydantic validation errors
    return detail.map(e => e.msg || e.message || JSON.stringify(e)).join(', ');
  }
  
  if (typeof detail === 'object' && detail.msg) {
    return detail.msg;
  }
  
  return defaultMessage;
}
